// extracted by mini-css-extract-plugin
export default {"formContainer":"team-form_formContainer__NpQOT","formSection":"team-form_formSection__hejWt","buttons":"team-form_buttons__IdE-z","submitButton":"team-form_submitButton__YomHK"};